/*
**	Functions for emulating menu features of the WFMT Pro theme header
**  by Nate Beversluis, 2020
*/

const menuItems = {
    '/': 								'li.menu-item a[href="/"]',
    '/listen': 							'li.menu-item a[href="/listen"]',
    '/schedule': 	 					'li.menu-item a[href="/schedule"]',
    '/programs':  						'li.menu-item a[href="/programs"]',
    '/stories' : 						'li.menu-item a[href="/stories"]',
    '/about-us' : 						'li.menu-item a[href="/about-us"]',
    '/support-wfmt': 					'li.menu-item a[href="/support-wfmt"]',
    '/support-wfmt/member-benefits' :   'li.menu-item a[href="/support-wfmt/member-benefits"]',
    '/podcasts' : 						'li.menu-item a[href="/podcasts"]',
    '/events' : 						'li.menu-item a[href="/events"]',
    };    

var allURLs = [];
for (var item in menuItems) allURLs.push(item);

function emulateMenuHighlights(URL) {

    if ( menuItems[URL] !== undefined ) {

        jQuery(menuItems[URL]).addClass('x-always-active');
        
        if (allURLs) {
            allURLs.forEach( function (item) {
                if ( item != URL ) {
                jQuery(menuItems[item]).removeClass('x-always-active');
                jQuery(menuItems[item]).removeClass('x-interactive');
                }
            });
        }
    }
}

function setupMobileMenu() {
    var links = jQuery('.x-menu-collapsed a');
    links.each(function() {
        var element = jQuery(this);
        element.addClass("mobile-menu-link");
        element.click( function() {
            jQuery('button.x-off-canvas-close').click();
        });
    });

    jQuery('.x-anchor-toggle').each( function() {
        jQuery(this).click( function () {
            jQuery(this).addClass('x-active');
        })
    })
}

export { setupMobileMenu, emulateMenuHighlights }